import { Navigate } from 'react-router'

export default function () {
  return <Navigate to="/settings2/billing" replace />
}
